export default {
  subheadline: 'This page allows you to customize the user-defined meanings for your own purposes. Changes are applied for all users.',
};
